"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const malty_atoms_icon_wrapper_1 = require("@carlsberggroup/malty.atoms.icon-wrapper");
const react_1 = __importDefault(require("react"));
const Refresh = (props) => (0, malty_atoms_icon_wrapper_1.IconWrapper)(props, react_1.default.createElement("g", { fillRule: "evenodd" },
    react_1.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
    react_1.default.createElement("path", { d: "M4.775 4.79A9.5 9.5 0 0121 11.5l-.002-.092 1.115-1.115a1 1 0 011.32-.083l.094.083a1 1 0 010 1.414l-2.8 2.8a1 1 0 01-1.413.001l-2.81-2.8a1 1 0 011.412-1.416l1.083 1.077A7.5 7.5 0 1011.518 19a1 1 0 11.004 2A9.5 9.5 0 014.775 4.79z" })));
exports.default = Refresh;
//# sourceMappingURL=index.js.map